import { render, staticRenderFns } from "./BoardCell.vue?vue&type=template&id=1210c7d9&scoped=true"
import script from "./BoardCell.vue?vue&type=script&lang=js"
export * from "./BoardCell.vue?vue&type=script&lang=js"
import style0 from "./BoardCell.vue?vue&type=style&index=0&id=1210c7d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1210c7d9",
  null
  
)

export default component.exports